import { useMemo } from 'react';
import useQueryUpcomingLaunches from '@/query/launches/useQueryUpcomingLaunches';
import dayjs from 'dayjs';

export const useLaunchData = (thisWeekRange: {
  start: dayjs.Dayjs;
  end: dayjs.Dayjs;
}) => {
  const { data: launchesData, isLoading: isLaunchesLoading } =
    useQueryUpcomingLaunches(thisWeekRange.start, thisWeekRange.end);

  const weeklyLaunchCount = useMemo(() => {
    if (!launchesData || !launchesData.results) return null;
    return launchesData.results.length;
  }, [launchesData]);

  const nextThreeLaunches = useMemo(() => {
    if (
      !launchesData ||
      !launchesData.results ||
      launchesData.results.length === 0
    )
      return [];
    return launchesData.results.slice(0, 5);
  }, [launchesData]);

  return {
    launchesData,
    weeklyLaunchCount,
    nextThreeLaunches,
    isLaunchesLoading,
  };
};
